export const environment = {
  production: false,
  apiUrl: 'https://api.test.iwanbooks.com/api/v1'
};

